import { useEffect, useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import { FiArrowRight, FiImage, FiLayers, FiPackage } from "react-icons/fi";

import PageHeader from "../../components/ui/PageHeader";
import StatCard from "../../components/ui/StatCard";
import Num from "../../components/ui/Num";
import routes, { canUse } from "../../routes";

const API = process.env.REACT_APP_API;
const auth = () => ({ headers: { Authorization: localStorage.getItem("token") } });

const readUser = () => {
  try {
    return JSON.parse(window.localStorage.getItem("user"));
  } catch {
    return null;
  }
};

/**
 * Boshqaruv sahifasi.
 *
 * Ilgari bu yerda faqat logotip va salomlashish turardi. Endi u ish holatini
 * ko'rsatadi: tovar ma'lumotnomasi qanchalik to'la, omborlardan nechtasi
 * ko'rinadi, kurs qanday.
 */
const MainPage = () => {
  const [photos, setPhotos] = useState(null);
  const [rate, setRate] = useState(null);
  const [warehouses, setWarehouses] = useState(null);
  const user = readUser();

  useEffect(() => {
    axios.get(`${API}/product/photos/overview`, auth()).then(({ data }) => setPhotos(data)).catch(() => {});
    axios.get(`${API}/exchange-rate/current`).then(({ data }) => setRate(data)).catch(() => {});
    axios.get(`${API}/warehouse`, auth()).then(({ data }) => setWarehouses(data)).catch(() => {});
  }, []);

  const coverage =
    photos && photos.total ? Math.round((photos.withPhotos / photos.total) * 100) : null;
  const visibleWarehouses = warehouses ? warehouses.filter((w) => !w.hidden).length : null;
  const rateValue = Array.isArray(rate) ? rate[0]?.price : rate?.price;

  const quickLinks = routes.filter(
    (r) => canUse(r, user) && ["/products", "/warehouses", "/trades"].includes(r.path)
  );

  return (
    <Box>
      <PageHeader
        title={`Assalomu alaykum, ${user?.firstName || ""}`}
        subtitle="Ma'lumot 1C dan har soatda yangilanadi."
      />

      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} lg={3}>
          <StatCard label="Tovarlar" value={photos?.total} icon={<FiPackage />} />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <StatCard
            label="Rasm qamrovi"
            value={coverage}
            suffix="%"
            hint={photos ? `${photos.withoutPhotos} ta tovarda rasm yo'q` : undefined}
            accent="#038681"
            icon={<FiImage />}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <StatCard
            label="Ko'rinadigan ombor"
            value={visibleWarehouses}
            hint={warehouses ? `jami ${warehouses.length} ta` : undefined}
            icon={<FiLayers />}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <StatCard label="Dollar kursi" value={rateValue} suffix="so'm" />
        </Grid>
      </Grid>

      {/* Rasm qamrovi -- o'lchagich */}
      {photos && photos.total > 0 && (
        <Paper sx={{ p: 3, mb: 4 }}>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 1.5 }}>
            <Typography variant="h4" sx={{ flexGrow: 1 }}>
              Tovar rasmlari
            </Typography>
            <Num value={photos.withPhotos} size="1rem" weight={600} />
            <Typography variant="body2" color="text.secondary">
              / <Box component="span" className="num">{photos.total}</Box>
            </Typography>
          </Box>
          <Box
            sx={{
              height: 10,
              borderRadius: 5,
              bgcolor: "action.hover",
              overflow: "hidden",
              display: "flex",
            }}
          >
            <Box sx={{ width: `${coverage}%`, bgcolor: "primary.main" }} />
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
            Rasmi yo'q tovarlar botda ham rasmsiz ko'rinadi. Yangi rasm qo'shish uchun
            “Tovar rasmlari” bo'limiga o'ting.
          </Typography>
        </Paper>
      )}

      <Grid container spacing={2}>
        {quickLinks.map((r) => (
          <Grid item xs={12} sm={6} lg={4} key={r.path}>
            <Paper
              component={Link}
              to={r.path}
              sx={{
                p: 2.5,
                display: "flex",
                alignItems: "center",
                gap: 2,
                textDecoration: "none",
                color: "text.primary",
                transition: "border-color .15s, transform .15s",
                "&:hover": { borderColor: "primary.main", transform: "translateY(-1px)" },
              }}
            >
              <Box
                sx={{
                  width: 38,
                  height: 38,
                  borderRadius: "10px",
                  display: "grid",
                  placeItems: "center",
                  bgcolor: "action.hover",
                  fontSize: 18,
                }}
              >
                {r.icon}
              </Box>
              <Typography variant="h5" sx={{ flexGrow: 1 }}>
                {r.name}
              </Typography>
              <Box sx={{ display: "flex", color: "text.secondary" }}>
                <FiArrowRight />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MainPage;
